import { UserOrganization } from 'types/access-control';

const roles = {
  'super-admin': {
    name: 'Super Admin',
    color: 'orange',
  },
  'ecustos-admin': {
    name: 'Suporte',
    color: 'orange',
  },
  'support-go': {
    name: 'Suporte GO',
    color: 'orange',
  },
  'organization-admin': {
    name: 'Administrador',
    color: 'brand',
  },
  'organization-user': {
    name: 'Gestor',
    color: 'blue',
  },
  'group-admin': {
    name: 'Construtora',
    color: 'green',
  },
  manager: {
    name: 'Gerenciadora',
    color: 'purple',
  },
  default: {
    name: 'Usuário',
    color: 'gray',
  },
};

type Key = keyof typeof roles;

export const getColorByRole = (roleArray: string[]): string => {
  for (let i = 0; i < roleArray.length; i += 1) {
    if (roleArray.includes(roleArray[i])) {
      return roles[roleArray[i] as Key].color;
    }
  }

  return roles.default.color;
};

export const getRoleName = (roleArray: string[]): string => {
  for (let i = 0; i < roleArray.length; i += 1) {
    if (roleArray.includes(roleArray[i])) {
      return roles[roleArray[i] as Key].name;
    }
  }

  return roles.default.name;
};

export const mergeRoles = (userData: UserOrganization): string[] => {
  return [
    userData.roles ? [...userData.roles] : [],
    userData.managed_organization?.roles
      ? [...userData.managed_organization.roles]
      : [],
  ].flat();
};

export const getUserRoleName = (userData: UserOrganization): string => {
  const userRoles = mergeRoles(userData);
  return getRoleName(userRoles);
};

export const SUPER_ADMIN = 'super-admin';
export const ECUSTOS_ADMIN = 'ecustos-admin';
export const SUPPORT_GO = 'support-go';
export const ORGANIZATION_ADMIN = 'organization-admin';
export const ORGANIZATION_USER = 'organization-user';
export const GROUP_ADMIN = 'group-admin';
export const MANAGER = 'manager';
export const DEFAULT = 'default';

const is =
  (role: string) =>
  (user: UserOrganization): boolean => {
    const userRoles = mergeRoles(user);
    return userRoles.includes(role);
  };

export const isSuperAdmin = is(SUPER_ADMIN);
export const isEcustosAdmin = is(ECUSTOS_ADMIN);
export const isSupportGo = is(SUPPORT_GO);
export const isOrganizationAdmin = is(ORGANIZATION_ADMIN);
export const isOrganizationUser = is(ORGANIZATION_USER);
export const isGroupAdmin = is(GROUP_ADMIN);
export const isManager = is(MANAGER);
export const isDefault = is(DEFAULT);

export const isBankAccount = (user: UserOrganization): boolean => {
  return isOrganizationAdmin(user) || isOrganizationUser(user);
};

export const isSuperOrEcustosOrGoAdmin = (user: UserOrganization): boolean => {
  return isSuperAdmin(user) || isEcustosAdmin(user) || isSupportGo(user);
};

export const createCanFunction =
  (user: UserOrganization) =>
  (guard: (user: UserOrganization) => boolean): boolean => {
    if (isSuperOrEcustosOrGoAdmin(user)) {
      return true;
    }

    return guard(user);
  };
